import { TProductStatus } from '../../core/types/Product'

export const getStatusChipStyles = (status: TProductStatus) => {
  const statusStyles = {
    [TProductStatus.Active]: {
      backgroundColor: 'rgba(28, 189, 63, 0.16)',
      color: 'rgba(0, 157, 35, 1)',
    },
    [TProductStatus.Inactive]: {
      backgroundColor: 'rgba(189, 28, 28, 0.16)',
      color: 'rgba(212, 54, 44, 1)',
    },
  }

  return statusStyles[status]
}
